/* import __COLOCATED_TEMPLATE__ from './custom-ember-table-data-cell.hbs.js'; */
import { alias, readOnly } from '@ember/object/computed';
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: '',
  i18n: service(),
  // passed in
  column: null,
  rowObject: null,
  value: null,
  parentRowClass: null,
  childRowClass: null,
  rowClass: computed('childRowClass', 'parentRowClass', 'rowObject.children.[]', function () {
    if (isEmpty(this.rowObject)) {
      return null;
    } else if (this.rowObject.children) {
      return this.parentRowClass;
    } else {
      return this.childRowClass;
    }
  }),
  // By default, the display value is the value of the cell we pass in. We can overwrite this attribute in the cell's
  // implementations
  displayValue: alias('value'),
  // By default, cellClass is pulled from the column definition. We can overwrite this attribute in the cell's implementation
  cellClass: readOnly('column.cellClass'),
  // By default, textClass is null. We can overwrite this attribute in the cell's implementations
  textClass: null
});